export type Event = {
  id: string;
  coverURL: string;
  name: string;
  description: string;
  communityId: string;
  categoryId: string;
  categoryName: string;
  startTime: string;
  endTime: string;
  // The IANA zone the coach set the times on, for example "Asia/Makassar".
  // Plain string on purpose, the way this copy keeps every enum-like field, so
  // a name the app accepts never breaks the admin build. startTime and endTime
  // stay UTC "Z" strings; this only names the clock.
  timezone?: string;
  createdAt: string;
  modifiedAt?: string;
  replayURL?: string;
  price: number;
  participants: string[];
  category?: { id: string; name: string };
  mediaGallery?: Array<string>; // URLs of images or videos
  popularityScore?: number;
  geolocation?: Geolocation;
  meetingURL?: string;
  address?: string;
  image?: any;
  reviews?: number;
  quantity?: number;
  logoURL?: string;
  tags?: string[];
  recurringDate?: { isActive: boolean; days: DayOfWeek[] };
  // Tier gating. Authored through the MCP, read-only in this admin app. When
  // requiredEntitlementIds is non-empty the event is gated: meetingURL and
  // replayURL live in Event/{id}/protected/links, and the public doc only
  // carries the two hasProtected flags. Loosely typed on purpose, so new values
  // added in the app never break the admin build.
  requiredEntitlementIds?: string[];
  entitlementMode?: string;
  unlockProductId?: string;
  lockedTitle?: string;
  lockedDescription?: string;
  hasProtectedMeetingURL?: boolean;
  hasProtectedReplayURL?: boolean;
};

export type DateWeek = {
  isActive: boolean;
  time: number;
  dayOfWeek: DayOfWeek;
};

export enum DayOfWeek {
  MON = "LUN",
  TUE = "MAR",
  WED = "MIE",
  THU = "JUE",
  FRI = "VIE",
  SAT = "SAB",
  SUN = "DOM",
}

export type EventCategory = {
  id: string;
  name: string;
  position: number;

  imageURL: string; // Adjust according to your data
  isActive: boolean;
  createdAt: string;
};
export default Event;
